import axios from 'axios';

const handleSubmit = (event) => {
  event.preventDefault();
  const form = document.getElementById('form-login');
  axios.get('/sanctum/csrf-cookie')
    .then(_ => {
      form.submit();
    });
}

document.querySelector('.js_login').addEventListener('click', handleSubmit);
document.getElementById('password')
  .addEventListener('keyup', function (event) {
    if (['NumpadEnter', 'Enter'].includes(event.code)) {
      handleSubmit(event)
    }
  });
